/**
 * Mirrors the plugin's view.js `ve(historyAll)`:
 *   - flattens historyAll.<auction> entries
 *   - stamps each with its auction key
 *   - derives a human-readable `status` from sold + sale_status
 *   - sorts by sale_date desc
 */
export function flattenHistoryAll(historyAll) {
  if (!historyAll || typeof historyAll !== "object") return [];
  const out = [];
  for (const [auction, bucket] of Object.entries(historyAll)) {
    if (!bucket) continue;
    const entries = Array.isArray(bucket) ? bucket : Object.values(bucket);
    for (const raw of entries) {
      if (!raw || typeof raw !== "object") continue;
      const sold = Boolean(raw.sold);
      const saleStatus = String(raw.sale_status ?? "");
      let status = "Not sold";
      if (sold && saleStatus === "Sold") status = "Sold";
      else if (sold && saleStatus !== "Sold") status = "Pending";
      else if (!sold && saleStatus === "Sold") status = "Pending";
      out.push({ ...raw, auction, status });
    }
  }
  out.sort((a, b) => (b?.sale_date ?? 0) - (a?.sale_date ?? 0));
  return out;
}

/** Plugin's money formatter `fe(e)` — groups thousands with dots. */
export function formatPrice(e) {
  if (e === null || e === undefined || e === "") return "0";
  return String(e).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1.");
}

/** Human-readable auction name used in the plugin table. */
export function prettyAuction(key) {
  if (!key) return "—";
  const v = String(key).toLowerCase();
  if (v === "copart" || v === "copart_canada") {
    const src = v;
    // "copart" -> "Copart", "copart_canada" -> "Copart_canada" keep simple
    return src === "copart" ? "Copart" : "Copart CA";
  }
  if (v === "iaai" || v === "iaai_canada") return v === "iaai" ? "IAAI" : "IAAI CA";
  if (v === "manheim") return "Manheim";
  if (v === "happy_car") return "HappyCar";
  if (v === "wind_motors_korea") return "WindMotors";
  return key.toUpperCase();
}

export const STATUS_CLASS = {
  Active: "active",
  Sold: "sold",
  "Not sold": "not-sold",
  Pending: "pending",
  "On Approval": "on-approval",
};

export const STATUS_COLOR = {
  Active: "#16a34a",
  Sold: "#2563eb",
  "Not sold": "#dc2626",
  Pending: "#d97706",
  "On Approval": "#64748b",
};
